module.exports = __webpack_public_path__ + "img/9788934945666.110d0dd5.jpg";